import axios from '../axios'
// 员工信息列表
export const baseEmployeeMsgExportPage = (data) => {
  return axios({
    url: '/api/sys/base/employee/baseEmployeeMsgExportPage',
    method: 'post',
    data
  })
}
// 流水明细列表
export const getRwJournalCapitalPage = (data) => {
  return axios({
    url: '/api/sys/rw/getRwJournalCapitalPage',
    method: 'post',
    data
  })
}

// 送货单报表
export const getPurArrivalReportPage = (data) => {
  return axios({
    url: '/api/sys/report/getPurArrivalReportPage',
    method: 'post',
    data
  })
}

// 采购订单统计表
export const getPurOrderReportPage = (data) => {
  return axios({
    url: '/api/sys/report/getPurOrderReportPage',
    method: 'post',
    data
  })
}

// 销售日报
export const getSalDailyReportPage = (data) => {
  return axios({
    url: '/api/sys/report/getSalDailyReportPage',
    method: 'post',
    data
  })
}

// 销售月报
export const getSalMonthlyReportPage = (data) => {
  return axios({
    url: '/api/sys/report/getSalMonthlyReportPage',
    method: 'post',
    data
  })
}

// 销售订单统计表
export const getSalOrderReportPage = (data) => {
  return axios({
    url: '/api/sys/report/getSalOrderReportPage',
    method: 'post',
    data
  })
}

// 销售占比表(每月)
export const getSalProportionReportMonthPage = (data) => {
  return axios({
    url: '/api/sys/report/getSalProportionReportMonthPage',
    method: 'post',
    data
  })
}

// 销售占比表(每日)
export const getSalProportionReportPage = (data) => {
  return axios({
    url: '/api/sys/report/getSalProportionReportPage',
    method: 'post',
    data
  })
}

// 采购单日报
export const getStkInPurchaseDailyReportList = (data) => {
  return axios({
    url: '/api/sys/report/getStkInPurchaseDailyReportList',
    method: 'post',
    data
  })
}

// 采购单月报
export const getStkInPurchaseMonthlyReportList = (data) => {
  return axios({
    url: '/api/sys/report/getStkInPurchaseMonthlyReportList',
    method: 'post',
    data
  })
}

// 采购入库单统计表
export const getStkInPurchaseReportPage = (data) => {
  return axios({
    url: '/api/sys/report/getStkInPurchaseReportPage',
    method: 'post',
    data
  })
}

// 采购单统计表
export const getStkInPurchaseReportPageList = (data) => {
  return axios({
    url: '/api/sys/report/getStkInPurchaseReportPageList',
    method: 'post',
    data
  })
}

// 销货单统计表
export const getStkOutSaleReportPage = (data) => {
  return axios({
    url: '/api/sys/report/getStkOutSaleReportPage',
    method: 'post',
    data
  })
}

// 客户充值统计表
export const getTuRechargeReportPage = (data) => {
  return axios({
    url: '/api/sys/report/getTuRechargeReportPage',
    method: 'post',
    data
  })
}

// 销售出库单统计表
export const getStkOutSaleByConditionPage = (data) => {
  return axios({
    url: '/api/sys/report/getStkOutSaleByConditionPage',
    method: 'post',
    data
  })
}

// 其他入库单统计表
export const getStkInOtherReportByConditionPage = (data) => {
  return axios({
    url: '/api/sys/report/getStkInOtherReportByConditionPage',
    method: 'post',
    data
  })
}

// 其他入库单明细列表
export const getStkInOtherReportDetailsPage = (data) => {
  return axios({
    url: '/api/sys/report/getStkInOtherReportDetailsPage',
    method: 'post',
    data
  })
}

// 产成品入库单统计表
export const getStkInProductReportByConditionPage = (data) => {
  return axios({
    url: '/api/sys/report/getStkInProductReportByConditionPage',
    method: 'post',
    data
  })
}

// 产成品入库单明细列表
export const getStkInProductReportDetailsPage = (data) => {
  return axios({
    url: '/api/sys/report/getStkInProductReportDetailsPage',
    method: 'post',
    data
  })
}

// 材料出库单统计表
export const getStkOutMaterialByConditionPage = (data) => {
  return axios({
    url: '/api/sys/report/getStkOutMaterialByConditionPage',
    method: 'post',
    data
  })
}

// 查询材料出库单明细列表
export const getStkOutMaterialReportDetailsPage = (data) => {
  return axios({
    url: '/api/sys/report/getStkOutMaterialReportDetailsPage',
    method: 'post',
    data
  })
}

// 其他出库单统计表
export const getStkOutOtherByConditionPage = (data) => {
  return axios({
    url: '/api/sys/report/getStkOutOtherByConditionPage',
    method: 'post',
    data
  })
}

// 查询其他出库单明细列表
export const getStkOutOtherReportDetailsPage = (data) => {
  return axios({
    url: '/api/sys/report/getStkOutOtherReportDetailsPage',
    method: 'post',
    data
  })
}

// 采购入库单明细列表
export const getStkInPurchaseReportDetailsPage = (data) => {
  return axios({
    url: '/api/sys/report/getStkInPurchaseReportDetailsPage',
    method: 'post',
    data
  })
}
// 销售出库单明细列表
export const getStkOutSaleReportDetailsPage = (data) => {
  return axios({
    url: '/api/sys/report/getStkOutSaleReportDetailsPage',
    method: 'post',
    data
  })
}
// 应收款列表
export const getAccountsReceivableList = (data) => {
  return axios({
    url: '/api/sys/fin/getAccountsReceivableList',
    method: 'post',
    data
  })
}
// 应收款明细列表
export const getAccountsReceivableDetailList = (data) => {
  return axios({
    url: '/api/sys/fin/getAccountsReceivableDetailList',
    method: 'post',
    data
  })
}
// 应付款列表
export const getAccountsPayableList = (data) => {
  return axios({
    url: '/api/sys/fin/getAccountsPayableList',
    method: 'post',
    data
  })
}
// 应付款明细列表
export const getAccountsPayableDetailList = (data) => {
  return axios({
    url: '/api/sys/fin/getAccountsPayableDetailList',
    method: 'post',
    data
  })
}
// 客户销售区域统计表
export const getPartnerAreaSaleReportList = (data) => {
  return axios({
    url: '/api/sys/report/getPartnerAreaSaleReportList',
    method: 'post',
    data
  })
}
// 应付款明细总合计
export const getAccountsPayableDetailSum = (data) => {
  return axios({
    url: '/api/sys/fin/getAccountsPayableDetailSum',
    method: 'post',
    data
  })
}
// 应收款明细列表总合计
export const getAccountsReceivableDetailSum = (data) => {
  return axios({
    url: '/api/sys/fin/getAccountsReceivableDetailSum',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/report.js